import { Component, OnInit, Input } from '@angular/core';
import { Category } from '@ncessor/shared';
import { NgIf } from '@angular/common';
import { MatListSubheaderCssMatStyler } from '@angular/material/list';
import { RouterLink } from '@angular/router';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-category-subheader',
  templateUrl: './category-subheader.component.html',
  styleUrls: ['./category-subheader.component.scss'],
  imports: [NgIf, MatListSubheaderCssMatStyler, RouterLink, MatIcon],
})
export class CategorySubheaderComponent implements OnInit {
  @Input() category: Category | null = null;

  constructor() {}

  ngOnInit(): void {}
}
